<template>
  <v-badge
  color="red"
  :content="value > 9 ? '9+' : value"
  :value="value"
  overlap>
    <slot/>
  </v-badge>
</template>

<script>
export default {
  props: {
    value: {
      type: Number,
      required: true
    }
  }
}
</script>

<style>

</style>